import React, { useCallback, useState, lazy, Suspense } from 'react';
import {
  Button,
  TextInput,
  NumberInput,
  Select,
  SelectItem,
  Checkbox,
  DataTable,
  TableRow,
  TableHead,
  TableHeader,
  TableContainer,
  TableCell,
  Table,
  TableBody,
  TableToolbar,
  TableToolbarContent,
} from 'carbon-components-react';

import Collapsible from 'react-collapsible';
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import { Tooltip as ReactTooltip } from "react-tooltip";


import { safeLoad, getDivHeight, jsonToYaml, updateStyle, updateStyle2, validateField, toggleDescription } from '../../helpers';



const handleChange = () =>{
    var yamlText = window.iagyaml;

    var json = {};

    if(yamlText !== null && yamlText !== undefined) {
        json = safeLoad(yamlText);
        if(json === undefined || json === null) {
          json = {};
        }
    }

    var newElem = {};
    if(document.getElementById("secrets_enc_key_id").value.endsWith(":") !== true) {
    newElem["enc_key"] = document.getElementById("secrets_enc_key_id").value;
    }
    if(document.getElementById("secrets_obf_key_id").value.endsWith(":") !== true) {
    newElem["obf_key"] = document.getElementById("secrets_obf_key_id").value;
    }
    json["secrets"] = newElem;

    var yamlop = jsonToYaml(json);
    window.iagyaml = yamlop;
};

  const closeAdd = (idPrefix) => {

      if(idPrefix === undefined) idPrefix = "";

      updateStyle("secrets_div" + idPrefix, "display", "block");
      document.getElementById("secrets_tab" + idPrefix).style.display = "flex";

  };



const SecretsPage = () => {

  const idPrefix = "";

  if(window.iagpage != "SecretsPage") {
    delete(window.editing);
    delete(window.rowId);
    window.iagpage = "SecretsPage";
  }



    const [secrets_enc_key, setsecrets_enc_key] = useState(''),
    updatesecrets_enc_key = useCallback((evt) => setsecrets_enc_key(evt.target.value), []);

    const [secrets_obf_key, setsecrets_obf_key] = useState(''),
    updatesecrets_obf_key = useCallback((evt) => setsecrets_obf_key(evt.target.value), []);


  if(window.iagpage != "SecretsPage") {
    delete(window.editing);
    delete(window.rowId);
    window.iagpage = "SecretsPage";
  }

    const [fetcheddata, setFetcheddata] = React.useState(false);
    React.useEffect(() => {
      dataLoad();
    }, [fetcheddata]);
    const dataLoad = () => {
      var yamlText = window.iagyaml;
      var json = {};
      if(yamlText !== null && yamlText !== undefined) {
        json = safeLoad(yamlText);
        if(json === undefined || json === null) {
          json = {};
        }
      }


      return true;
    };
    const [fetchedsecrets, setFetchedsecrets] = React.useState(false);
    React.useEffect(() => {
      getsecrets();
    }, [fetchedsecrets]);

    const getsecrets = () => {

      var yamlText = window.iagyaml;
      var json = {};
      if(yamlText !== null && yamlText !== undefined) {
        json = safeLoad(yamlText);
        if(json === undefined || json === null) {
          json = {};
        }
      }


        if(json !== undefined && json.secrets !== undefined ) {
          if(json !== undefined && json.secrets !== undefined && json.secrets.enc_key !== undefined ) {
            setsecrets_enc_key(json.secrets.enc_key);
          }
          if(json !== undefined && json.secrets !== undefined && json.secrets.obf_key !== undefined ) {
            setsecrets_obf_key(json.secrets.obf_key);
          }
        }
    };



    const setDataMain = (functionName, data) => {
      if(functionName && data) {
        eval(functionName)(data);
      }
    };

    return (
        <div className="bx--grid--no-gutter bx--grid--full-width landing-page">
          <div className="bx--row landing-page__banner" style={{paddingBottom:"3rem"}}>
            <div className="bx--col-lg-13 bx--offset-lg-1">
              <h1 className="landing-page__heading">
                Secrets
              </h1>
            </div>
            <div className="bx--col-lg-13 bx--offset-lg-1">
              <h4 className="landing-page__desc" style={{marginTop:"30px"}}>The `secrets` node defines secret data which can be used to obfuscate or encrypt entries within the YAML configuration documents.
</h4>
            </div>            <div id="warning_div" className="bx--col-lg-13" style={{display:'none', color:'red', position:'absolute', bottom:'0', marginBottom: '10px'}}></div>
          </div>
          <div className="bx--row landing-page__r2">
            <div className="bx--col bx--no-gutter">
              <div id="secretsPage" className="bx--col">
                <br/><br/><br/>
            <Tabs id={"secrets_tab" + idPrefix} defaultTab={"General_tab" + idPrefix} vertical className="vertical-tabs" style={{overflow:'auto'}}>
              <TabList>
                <Tab tabFor={"General_tab" + idPrefix}>General</Tab>
              </TabList>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"General_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading secrets_div" + idPrefix}>
                  <span className="iag_breadcrumb">Secrets : </span><br/>                  <h2>General Settings</h2><hr/>
                  Specifies the general settings associated with this component
                </div>
                <div className={"iag--simple-div secrets_div" + idPrefix}>
                <div className= {"iag_form_elem secrets_div" + idPrefix}>
          <TextInput  value={secrets_enc_key}  id={"secrets_enc_key_id" + idPrefix}  data-tooltip-id={"secrets_enc_key_tooltip_id" + idPrefix}  labelText="Encryption Key" onChange={(evt) => { updatesecrets_enc_key(evt); handleChange(); }}/>
          <ReactTooltip id={"secrets_enc_key_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" class="tooltipScroll" delayHide={500}><div style={{ maxWidth: '50vw', maxHeight: 300, overflowY: 'scroll' }}>Specifies an encryption key which is used to decrypt the `ENC:&lt;data&gt;` type entries.<br/><br/>The encryption key is an RSA private key which can be used to decrypt entries which were encrypted using the corresponding RSA public key.<br/><br/>This entry must be a PEM representation of an RSA private key, beginning with `-----BEGIN RSA PRIVATE KEY-----` and ending with `-----END RSA PRIVATE KEY-----`.<br/><br/><h4> Example Steps:</h4><br/><br/>An RSA key pair can be created with the following commands:<br/><br/>Generate the RSA private key:<br/><br/>```shell<br/>openssl genrsa -out private.pem 2048<br/>```<br/><br/>Generate the corresponding public key:<br/><br/>```shell<br/>openssl rsa -pubout -in private.pem -out public.pem<br/>```<br/><br/>An encrypted entry can be generated with the following command using the public key:<br/><br/>```shell<br/>echo -n "&lt;configuration entry&gt;" | openssl rsautl<br/><table style={{textAlign:'left', border:'1px solid black'}}><tbody><tr style={{textAlign:'left', border:'1px solid black'}}><th style={{borderRight:'1px solid black', padding: '10px'}}>    -encrypt -inkey public.pem -pubin </th><th style={{borderRight:'1px solid black', padding: '10px'}}> base64</th></tr></tbody></table><br/>oYpkxULIexyLR2wUl+mz6Nfki8Pd23Fv0buZZxAuh+Cq1A677NTZwmcWcWN9+MBBVJaISNM0uIVd33/n83Awf77Q/LXtjtzsk41Ux690YVsagh75n/BPk7Ca+4txzwB48yOrTKtIRVbNC2H+Rpa/7LMNSc1Zjez9PqNO4WIa323NzKA4y3Cx1h3DTKANrgsJgXDHNWNs/Ar9pPXxSeFNGmgnYRVtEZtN73IAMs8TzNJKNGkBkmr6vdZvlkjI6ebezJS1kawDvaKQ/C5GXdbpoaJE+JYgYsHDEZLpiasn0Ii4yt3HHNKpsX0UUBSIMO3di0brjJPoJFccVPHLDYgPlw==<br/>```<br/><br/>This encryption key and encrypted entry can be provided in the configuration YAML.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem secrets_div" + idPrefix}>
          <TextInput  value={secrets_obf_key}  id={"secrets_obf_key_id" + idPrefix}  data-tooltip-id={"secrets_obf_key_tooltip_id" + idPrefix}  labelText="Obfuscation Key" onChange={(evt) => { updatesecrets_obf_key(evt); handleChange(); }}/>
          <ReactTooltip id={"secrets_obf_key_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" class="tooltipScroll" delayHide={500}><div style={{ maxWidth: '50vw', maxHeight: 300, overflowY: 'scroll' }}>Specifies an obfuscation key which is used to decrypt the `OBF:&lt;data&gt;` type entries.<br/><br/>The obfuscation key is a passphrase which can be used to perform key derivation to generate the key used to decrypt obfuscated entries.<br/><br/><h4> Example Steps:</h4><br/><br/>An obfuscated entry can be generated with the following command which requires OpenSSL 1.1.1 or newer:<br/><br/>```shell<br/>echo -n "&lt;configuration entry&gt;" | openssl enc -aes256<br/>    -pbkdf2 -pass pass:"&lt;obfuscation key&gt;" -md sha512<br/>    -base64<br/><br/>U2FsdGVkX19iBhlwc53+QkybjO6RjFHhSbz4VRudYHA=<br/>```<br/><br/>This obfuscation key and obfuscated entry can be provided in the configuration YAML.<br/></div></ReactTooltip>
        </div>

                </div>
              </TabPanel>
            </Tabs>
              </div>
            </div>
          </div>
        </div>
    );
};
export default SecretsPage;
